import { createAction } from 'redux-actions';

import {
  LOAD_ORGANISATION_LIST,
  LOAD_ORGANISATION_LIST_SUCCESS,
  LOAD_ORGANISATION_LIST_ERROR,
  LOAD_ORGANISATION_DETAIL,
  LOAD_ORGANISATION_DETAIL_SUCCESS,
  LOAD_ORGANISATION_DETAIL_ERROR,
  LOAD_COMPANY_SITE_LIST,
  LOAD_COMPANY_SITE_LIST_SUCCESS,
  LOAD_COMPANY_SITE_LIST_ERROR,
  LOAD_COMPANY_SITE_DETAIL,
  LOAD_COMPANY_SITE_DETAIL_SUCCESS,
  LOAD_COMPANY_SITE_DETAIL_ERROR,
} from './type';

//Load list organisation
export const loadOrganisationListAction = createAction(LOAD_ORGANISATION_LIST);
export const loadOrganisationListSuccessAction = createAction(
  LOAD_ORGANISATION_LIST_SUCCESS,
);
export const loadOrganisationListErrorAction = createAction(
  LOAD_ORGANISATION_LIST_ERROR,
);

//Load organisation detail
export const loadOrganisationDetailAction = createAction(
  LOAD_ORGANISATION_DETAIL,
);
export const loadOrganisationDetailSuccessAction = createAction(
  LOAD_ORGANISATION_DETAIL_SUCCESS,
);
export const loadOrganisationDetailErrorAction = createAction(
  LOAD_ORGANISATION_DETAIL_ERROR,
);

//Load company site list
export const loadCompanySiteListAction = createAction(LOAD_COMPANY_SITE_LIST);
export const loadCompanySiteListSuccessAction = createAction(
  LOAD_COMPANY_SITE_LIST_SUCCESS,
);
export const loadCompanySiteListErrorAction = createAction(
  LOAD_COMPANY_SITE_LIST_ERROR,
);

//Load company site list
export const loadCompanySiteDetailAction = createAction(
  LOAD_COMPANY_SITE_DETAIL,
);
export const loadCompanySiteDetailSuccessAction = createAction(
  LOAD_COMPANY_SITE_DETAIL_SUCCESS,
);
export const loadCompanySiteDetailErrorAction = createAction(
  LOAD_COMPANY_SITE_DETAIL_ERROR,
);
